import { createFileRoute } from '@tanstack/react-router'
import { toast } from 'sonner'
import PageContainer from '@/components/page-container'
import RoleManagementForm from '@/routes/admin/management/roles/-components/role-management-form'
import $api from '@/services/api'

export const Route = createFileRoute('/admin/management/roles/$id')({
  component: UpdateRoleManagement,
  staticData: {
    breadcrumb: 'Detail',
  },
  loader: async ({ params, context: { queryClient } }) => {
    await queryClient.ensureQueryData(
      $api.queryOptions('get', '/roles/{id}', {
        params: {
          path: {
            id: params.id,
          },
        },
      }),
    )
  },
})

function UpdateRoleManagement() {
  const { id } = Route.useParams()
  const { data, refetch } = $api.useSuspenseQuery('get', '/roles/{id}', {
    params: {
      path: { id },
    },
  })

  const mutation = $api.useMutation('patch', '/roles/{id}', {
    onSuccess: async () => {
      toast.success('Role updated successfully')
      await refetch()
    },
    onError: () => {
      toast.error('Failed to update role')
    },
  })

  return (
    <PageContainer
      title="Update Role Management"
      backUrl="/admin/management/roles"
    >
      <RoleManagementForm
        defaultValues={{
          name: data.data.name,
          permissions: data.data.permissionJson as unknown as Record<
            string,
            boolean
          >,
        }}
        onSubmit={async (data) => {
          await mutation.mutateAsync({
            body: {
              name: data.name,
              permissionJson: data.permissions as never,
            },
            params: {
              path: { id },
            },
          })
        }}
      />
    </PageContainer>
  )
}
